/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EpochEnum {
    All = 1,
    Draft = 2,
    New = 3,
    Review = 100,
    ReviewAdmin = 101,
    ReviewBank = 102,
    ChangesRequired = 200,
    Confirmed = 300,
    ConfirmedAdmin = 301,
    ExpectConfirmation = 302,
    ExpectingSigning = 303,
    ExpectingPayment = 304,
    InProgress = 400,
    ReceiptOfMoney = 401,
    Completed = 500,
    Accomplished = 600,
    Blocked = -200,
    Refusal = -101,
    Rejected = -100,
}
